<template>
    <div class="Notificacion">
        <v-container grid-list-xl fluid class="pt-0">
            <v-layout row wrap>
                <v-flex sm12>
                    <v-card>
                        <v-toolbar color="primary" dark flat>
                            <v-toolbar-title>
                                <v-icon medium>fa-bell</v-icon>
                                Notificaciones del usuario
                            </v-toolbar-title>

                            <v-divider class="px-1" inset vertical></v-divider>

                            <v-flex sm3 class="pa-0" style="max-width: 190px">
                                <v-overflow-btn
                                    v-model="notificacionEstado"
                                    label="Notificación"
                                    :items="[
                                        { text: 'Todas', value: '1' },
                                        { text: 'Sin leer', value: '2' },
                                        { text: 'Leídas', value: '3' }
                                    ]"
                                    hide-details
                                    class="pa-0"
                                    @change="LoadNotificacion"
                                >
                                    <template v-slot:item="data">
                                        <v-list-tile-content>
                                            <v-card-text class="pa-0 ">
                                                <v-icon
                                                    :color="getIconColor(data)"
                                                    class="pr-3"
                                                    v-if="data.item.value !== '1'"
                                                    >fa-list</v-icon
                                                >
                                                {{ data.item.text }}
                                            </v-card-text>
                                        </v-list-tile-content>
                                    </template>
                                </v-overflow-btn>
                            </v-flex>

                            <v-divider class="px-1" inset vertical></v-divider>

                            <v-spacer></v-spacer>

                            <v-toolbar-items>
                                <v-btn icon @click="toogleSearch()">
                                    <v-icon medium>fa-search</v-icon>
                                </v-btn>

                                <v-expand-x-transition>
                                    <v-text-field
                                        hide-details
                                        solo
                                        v-show="searchShow"
                                        v-model="filter.search"
                                        placeholder="Filtrar"
                                        class="hidden-sm-and-down pt-2"
                                    >
                                    </v-text-field>
                                </v-expand-x-transition>

                                <v-menu
                                    v-model="filtroMenu"
                                    origin="center center"
                                    class="elelvation-1"
                                    transition="slide-y-transition"
                                    top
                                    left
                                    min-width="500"
                                    max-height="500"
                                    :close-on-content-click="false"
                                >
                                    <template v-slot:activator="{ on: menu }">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on: tooltip }">
                                                <v-btn icon flat>
                                                    <v-badge color="orange" overlap>
                                                        <span slot="badge" v-if="activeFilters > 0">{{
                                                            activeFilters
                                                        }}</span>
                                                        <v-icon medium v-on="{ ...tooltip, ...menu }">fa-filter</v-icon>
                                                    </v-badge>
                                                </v-btn>
                                            </template>
                                            <span>Filtro Personalizado</span>
                                        </v-tooltip>
                                    </template>
                                    <custom-filter-user-notificacion
                                        v-if="filtroMenu"
                                        :internal-state="filterInternalState"
                                        @applyFilter="applyFilter"
                                    ></custom-filter-user-notificacion>
                                </v-menu>
                            </v-toolbar-items>
                        </v-toolbar>
                        <v-divider></v-divider>
                        <v-card-text class="pa-0">
                            <v-data-table
                                :headers="headers"
                                :loading="loading"
                                :pagination.sync="pagination"
                                :rows-per-page-items="pagination.rowsPerPageItems"
                                :total-items="totalItems"
                                :items="USER_NOTIFICACIONES"
                                class="elevation-1"
                                item-key="id"
                            >
                                <v-progress-linear v-slot:progress color="green" indeterminate></v-progress-linear>
                                <template slot="items" slot-scope="props">
                                    <tr>
                                        <td class="pt-2">
                                            {{
                                                props.item.notificationGestor
                                                    ? props.item.notificationGestor.nombre
                                                    : "-"
                                            }}
                                        </td>
                                        <td>
                                            {{
                                                props.item.notificationGestor
                                                    ? props.item.notificationGestor.descripcion
                                                    : "-"
                                            }}
                                        </td>
                                        <td>
                                            <v-chip
                                                small
                                                dark
                                                label
                                                :color="getChipLabelColor(props.item)"
                                                style="font-size: 12px"
                                            >
                                                {{ props.item.status_lectura ? props.item.status_lectura : "-" }}
                                            </v-chip>
                                        </td>
                                        <td class="pl-0">
                                            <v-layout class="justify-end">
                                                <div class="action-column" style="width: 52px">
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on }">
                                                            <v-btn
                                                                flat
                                                                icon
                                                                :color="props.item.leida === 2 ? 'success' : 'red'"
                                                                :loading="loadingStatusLeida"
                                                                :disabled="loading || menuLocked"
                                                                @click="modificarLectura(props.item)"
                                                            >
                                                                <v-icon medium v-on="on">{{
                                                                    props.item.leida === 2
                                                                        ? "fa-thumbs-up"
                                                                        : "fa-thumbs-down"
                                                                }}</v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <span>{{
                                                            props.item.leida === 2
                                                                ? "Modificar a Leida"
                                                                : "Modificar a Sin leer"
                                                        }}</span>
                                                    </v-tooltip>
                                                </div>
                                            </v-layout>
                                        </td>
                                    </tr>
                                </template>
                                <template slot="no-data">
                                    <div style="text-align: center">
                                        No existen tareas registradas en el sistema.
                                    </div>
                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
import _ from "lodash"
const CustomFilterUserNotificacion = () =>
    import(/* webpackChunkName: "filtro-notificacion" */ "@/components/widgets/custom-filter-notificacion/custom-filter-user-notificacion")

export default {
    components: { CustomFilterUserNotificacion },
    props: {
        estado: { type: String, default: null }
    },
    data: () => ({
        searchShow: false,
        loading: false,
        headers: [
            { text: "Nombre", value: "notificationGestor" },
            { text: "Descripción", value: "notificationGestor" },
            { text: "Lectura", sortable: false },
            { sortable: false }
        ],
        editItem: null,
        filter: {
            search: ""
        },
        totalItems: 0,

        menuLocked: false,

        //estado de los tareas a cargar del back
        notificacionEstado: "2",

        //opcion para mostrar cuando se despliega la fila expand
        rowExpandedOption: null,

        //modificar el estado de lectura
        loadingStatusLeida: false,

        //filtro personalizado
        filtroMenu: false,
        customFilter: null,
        activeFilters: 0,

        //para saber si ya se aplico el valor obtenido por las props
        estadoApplied: false,

        //estado interno del filtro
        filterInternalState: null
    }),

    methods: {
        toogleSearch: function() {
            this.searchShow = !this.searchShow
        },

        loadData(estado, customFilter) {
            this.loading = true
            this.$store
                .dispatch("LOAD_USER_NOTIFICACIONES", {
                    currentUser: this.$store.getters.CURRENT_USER.id,
                    filter: this.filter.search,
                    notificacionEstado: estado,
                    customfilter: customFilter
                })
                .then(result => {
                    this.loading = false
                    this.totalItems = result
                })
        },

        LoadNotificacion() {
            this.loadData(this.notificacionEstado)
            this.customFilter = null
            this.activeFilters = 0
        },

        searchData: _.debounce(function() {
            this.loadData(this.notificacionEstado)
        }, 1000),

        getIconColor(data) {
            switch (data.item.value) {
                case "1":
                    return "black"
                case "2":
                    return "red lighten-1"
                case "3":
                    return "success lighten-1"
                default:
                    return "black"
            }
        },

        modificarLectura(item) {
            this.loadingStatusLeida = true
            this.$store.dispatch("UPDATE_USER_NOTIFICACION", item).then(() => {
                this.loadingStatusLeida = false
                this.$store.dispatch("LOAD_USER_UNREAD_NOTIFICACIONES", this.$store.getters.CURRENT_USER)
            })
        },

        applyFilter(value) {
            if (value.activeFilters > 0) {
                this.filtroMenu = false
                this.notificacionEstado = "6"
                this.customFilter = value.customFilter
                this.activeFilters = value.activeFilters
                this.loadData(this.notificacionEstado, this.customFilter)
            } else {
                this.notificacionEstado = "1"
                this.customfilter = null
                this.activeFilters = 0
                this.loadData(this.notificacionEstado, this.customfilter)
                this.filtroMenu = false
            }
            this.filterInternalState = { inputs: value.inputs, selectedCampos: value.selectedCampos }
        },

        getChipLabelColor(item) {
            switch (item.leida) {
                case 2:
                    return "red lighten-1"
                case 1:
                    return "success lighten-1"
            }
        }
    },

    computed: {
        ...mapGetters(["USER_NOTIFICACIONES"]),

        pagination: {
            get: function() {
                return this.$store.getters.USER_NOTIFICACIONES_PAG
            },
            set: function(value) {
                this.$store.commit("SET_USER_NOTIFICACIONES_PAG", value)
            }
        },
        searchTerm() {
            return this.filter.search
        }
    },

    watch: {
        pagination: {
            handler() {
                if (this.estado && !this.estadoApplied) {
                    //si se envio el valor estado por las props y no se ha aplicado, se aplica una sola vez
                    this.notificacionEstado = this.estado
                    this.estadoApplied = true
                }
                this.loadData(this.notificacionEstado, this.customFilter)
            },
            deep: true
        },
        searchTerm() {
            this.searchData()
        }
    }
}
</script>
